import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import TextCounter from '../../../components/TextCounter';

const styles = () => ({
  Grid: {
    marginTop: 35,
  },
});

const ExperienceForm = props => {
  const [numChar, setNumChar] = useState(0);
  const [ringStyle, setRingStyle] = useState({
    stroke: '',
    strokeDasharray: '',
  });

  const styleRing = numCharacters => {
    const r = 15;
    const circleLength = 2 * Math.PI * r;
    const mint = '#35b9b6';

    let colored = (circleLength * numCharacters) / 2000;
    let gray = circleLength - colored > 0 ? circleLength - colored : 0;

    setRingStyle({
      stroke:
        2000 - numCharacters === 0
          ? 'red'
          : 1500 - numCharacters <= 20
          ? 'orange'
          : mint,
      strokeDasharray: `${colored} ${gray}`,
    });
  };

  const countChar = event => {
    setNumChar(event.target.value.length);
    styleRing(event.target.value.length);
  };

  const handleChangeMultiple = field => event => {
    event.preventDefault();
    let value = event.target.value;
    setFieldValue(field, value);
  };

  const {
    // dirty,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
  } = props;

  return (
    <form>
      <Grid
        container
        direction="column"
        justify="center"
        classes={{ root: classes.Grid }}
      >
        <div>
          <TextCounter
            txtLabel="Descripción experiencia"
            countChar={countChar}
            numChar={numChar}
            handleChange={handleChangeMultiple('experience')}
            ringStyle={ringStyle}
            errors={errors.experience}
            touched={touched.experience}
            handleBlur={handleBlur}
            name={'experience'}
            values={values.experience}
            maxLenghtNum={2000}
          />
        </div>
      </Grid>

      <div className="horizontal-layout" style={{ marginTop: 15 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(ExperienceForm);
